module.exports = __webpack_public_path__ + "img/nigerian-flag.30bb7214.svg";